import LargePanels from '@/components/LP/LargePanels';
import SmallPanels from '@/components/SP/SmallPanels';
import ComparisonReport from '@/components/CR/ComparisonReport';
import Menu from '@/components/Menu';

const titlePrefix = process.env.SystemName;
const titleSuffix = process.env.PageTitleSuffix;
const homeUrl = process.env.HomeUrl;

export default [
  {
    path: '/LP',
    name: 'LargePanels',
    component: LargePanels,
    meta: {
      title: `${titlePrefix} Explore by Indicator ${titleSuffix}`,
      pageTitle: 'Explore by Indicator',
      metaTags: [
        {
          name: 'description',
          content: 'LP description goes here',
        },
        {
          name: 'keywords',
          content: 'LP keywords go here',
        },
      ],
    },
  },
  {
    path: '/SP',
    name: 'SmallPanels',
    component: SmallPanels,
    meta: {
      title: `${titlePrefix} Explore by Location ${titleSuffix}`,
      pageTitle: 'Explore by Location',
      metaTags: [
        {
          name: 'description',
          content: 'SP description goes here',
        },
        {
          name: 'keywords',
          content: 'SP keywords go here',
        },
      ],
    },
  },
  {
    path: '/CR',
    name: 'ComparisonReport',
    component: ComparisonReport,
    meta: {
      title: `${titlePrefix} Comparison Report ${titleSuffix}`,
      pageTitle: 'Comparison Report',
      metaTags: [
        {
          name: 'description',
          content: 'CR description goes here',
        },
        {
          name: 'keywords',
          content: 'CR keywords go here',
        },
      ],
    },
  },
  {
    path: '/menu',
    name: 'Menu',
    component: Menu,
    meta: {
      title: `${titlePrefix} Test menu ${titleSuffix}`,
      pageTitle: 'Test menu',
    },
  },
  {
    path: process.env.HomeUrl,
    name: 'wcms',
    // work around for route to an external link
    // https://github.com/vuejs/vue-router/issues/1280#issuecomment-356976705
    beforeEnter() {
      document.location.href = homeUrl;
    },
  },
  // default route
  {
    path: '*',
    redirect: { name: process.env.DefaultRouteName },
  },
];




// WEBPACK FOOTER //
// ./src/router/routes.js